import request from '@/utils/request'

// 根据申请明细ID查询成本构成
export function getComposeInfoByLineId(lineId) {
  return request({
    url: '/api/srm-slcm/pmMatCostApplyCompose/getComposeInfoByLineId/' + lineId,
    method: 'get'
  })
}

// 根据明细ID查询成本构成对比数据
export function getCompareComposeByLineId(lineId) {
  return request({
    url: '/api/srm-slcm/pmMatCostApplyCompose/getCompareComposeByLineId/' + lineId,
    method: 'get'
  })
}

// 根据明细ID查询成本构成汇总数据
export function summaryComposeInfoByLineId(lineId) {
  return request({
    url: '/api/srm-slcm/pmMatCostApplyCompose/summaryComposeInfoByLineId/' + lineId,
    method: 'get'
  })
}
